import { useCallback } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { generateID } from "../helpers/widgetsCharts";
import { Toast } from "../helpers/alert";

export const useImageExport = (
  firstSelect,
  meterSelected,
  startDate,
  endDate
) => {
  const captureScreen = useCallback(async () => {
    const chart =
      document.querySelector("#graph canvas") ||
      document.querySelector("#graph");
    const canvas = await html2canvas(chart, {
      backgroundColor: "#fff",
      useCORS: true,
    });
    const link = document.createElement("a");
    link.download = "chart.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  }, []);

  const getBase64Image = useCallback(async () => {
    const chart =
      document.querySelector("#graph canvas") ||
      document.querySelector("#graph");
    const canvas = await html2canvas(chart, {
      backgroundColor: "#fff",
      useCORS: true,
    });
    return canvas.toDataURL("image/png");
  }, []);

  const exportToPDF = useCallback(
    async (inputRef) => {
      const chart =
        inputRef.current.querySelector("canvas") || inputRef.current;
      const canvas = await html2canvas(chart, {
        backgroundColor: "#fff",
        useCORS: true,
      });
      const imageData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imageData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const width = pdfWidth;
      const height = (imgProps.height * width) / imgProps.width;
      const x = (pdfWidth - width) / 2;
      const y = (pdfHeight - height) / 4;

      pdf.addImage(imageData, "PNG", x, y, width, height);

      const headerText = `Company: ${firstSelect.name} Mac: ${meterSelected.mac} ${meterSelected.primary_group} ${meterSelected.measureType}`;
      const dateText = `${startDate} - ${endDate}`;

      pdf.text(pdf.splitTextToSize(headerText, pdfWidth - 20), 10, 10);
      pdf.text(pdf.splitTextToSize(dateText, pdfWidth - 20), 10, 20);

      pdf.save("download.pdf");
    },
    [firstSelect.name, meterSelected, startDate, endDate]
  );

  const handleImageExport = useCallback(
    async (inputRef, calculateResults) => {
      const imageBase64 = await getBase64Image();
      const name = document.querySelector('input[name="name"]').value;

      const startEndText = `En las fechas ${startDate} y ${endDate}`;
      const resultsText = Object.entries(calculateResults)
        .map(
          ([key, val]) =>
            `El valor máximo en ${key} presentado es ${val.max} y el valor mínimo presentado es ${val.min} `
        )
        .join("");

      const data = {
        id: generateID(),
        company: firstSelect.name,
        mac: meterSelected.mac,
        name,
        primary_group: meterSelected.primary_group,
        place: meterSelected.place,
        measureType: meterSelected.measureType,
        results: calculateResults,
        text: resultsText,
        startEnd: startEndText,
        image: imageBase64,
      };

      const storedData = JSON.parse(
        localStorage.getItem("downloadData") || "[]"
      );
      if (storedData.length < 9) {
        localStorage.setItem(
          "downloadData",
          JSON.stringify([...storedData, data])
        );
        Toast.fire({
          icon: "success",
          title: "PDF Enviado!",
        });
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      } else {
        Toast.fire({
          icon: "info",
          title: "No se puede enviar mas de 9 archivos!",
        });
      }
    },
    [firstSelect.name, meterSelected, startDate, endDate, getBase64Image]
  );

  return {
    captureScreen,
    exportToPDF,
    handleImageExport,
  };
};
